var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header-gnb"},[_c('div',{staticClass:"header-component"},[_c('div',{staticClass:"header-logo"},[_c('router-link',{staticClass:"logo-link",attrs:{"to":"/"}},[_c('i',{staticClass:"logo"}),_c('span',{staticClass:"sr-only"},[_vm._v("살맛나는 행복쇼핑 동행축제 2024")])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }